import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { maxMediaQueries, minMediaQueries } from '@finect/tabular-utils/mediaQueries';
var withIframeStyles = css(["height:414px;", ";"], maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    height: 100%;\n  "]))));
export var ContentWrapper = styled.div.withConfig({
  displayName: "ContentWrapper",
  componentId: "sc-1w12gwl-0"
})(["", " ", " > iframe{width:100%;height:100%;border:0;border-radius:4px;}", ";"], function (_ref) {
  var withIframe = _ref.withIframe;
  return withIframe && withIframeStyles;
}, function (_ref2) {
  var withIframe = _ref2.withIframe;
  return !withIframe && 'height: 100%;';
}, minMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", "\n\n      @media (min-height: 1024px) {\n        ", "\n      }\n\n      @media (min-height: 1024px) {\n        ", ";\n      }\n    "])), function (_ref3) {
  var minHeight = _ref3.minHeight;
  return minHeight ? "height: ".concat(minHeight, ";") : '';
}, function (_ref4) {
  var heightSize = _ref4.heightSize,
    minHeight = _ref4.minHeight;
  return !minHeight && heightSize === 'medium' && 'height: 667px;';
}, function (_ref5) {
  var heightSize = _ref5.heightSize,
    minHeight = _ref5.minHeight;
  return !minHeight && heightSize === 'large' && "height: 896px;";
}));